/* ----------------------------------------------------
              Imports
----------------------------------------------------- */
import * as ActiveStorage from "@rails/activestorage";
import Rails from "@rails/ujs";
import "trix";
import "@rails/actiontext";
import * as Turbo from "@hotwired/turbo-rails";

// Start Rails UJS and ActiveStorage
Rails.start();
ActiveStorage.start();


/* ----------------------------------------------------
              Stimulus
----------------------------------------------------- */
import "./controllers/index";

/* ----------------------------------------------------
              Vendor
----------------------------------------------------- */
import "./vendor/chartjs";
import "./vendor/choices";
import "./vendor/filestack";
import "./vendor/active_storage";
import "./vendor/stripe";
import "./vendor/tippy";
import "./vendor/trix";

/* ----------------------------------------------------
              Components
----------------------------------------------------- */
import "./components/checkbox";
import "./components/confetti";
import "./components/field";
import "./components/form";
import "./components/google_maps_manager";
import "./components/mapbox_manager";
import "./components/input";
import "./components/modal";
import "./components/nav";
import "./components/radios";
import "./components/select";
import "./components/sticky";
import "./components/tabs";

/* ----------------------------------------------------
              Pages
----------------------------------------------------- */
import "./pages/calendar/index";
import "./pages/directories/show";
import "./pages/guides/show";
import "./pages/heartbeat/index";
import "./pages/home/index";
import "./pages/job_announcements/new";
import "./pages/job_changes/job_change";
import "./pages/job_changes/update";
import "./pages/job_files/view/show";
import "./pages/job_transactions/shared/new";
import "./pages/jobs/view/index";
import "./pages/jobs/form";
import "./pages/jobs/view/show_activity";
import "./pages/landing/index";
import "./pages/notes/note";
import "./pages/notes/create";
import "./pages/notes/destroy";
import "./pages/notes/update";
